/**
 * @generated SignedSource<<7b6f5405dff63b74588a4c6d3daf720c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
export type VanityUrlMessage_Query$variables = {
  userId: string;
};
export type VanityUrlMessage_Query$data = {
  readonly user: {
    readonly jobApplications?: {
      readonly totalCount: number | null | undefined;
    } | null | undefined;
    readonly profile?: {
      readonly openToOpportunities: boolean | null | undefined;
      readonly slug: string | null | undefined;
    } | null | undefined;
    readonly self?: boolean | null | undefined;
    readonly status?: UserStatus | null | undefined;
  } | null | undefined;
};
export type VanityUrlMessage_Query = {
  response: VanityUrlMessage_Query$data;
  variables: VanityUrlMessage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "self",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "openToOpportunities",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": "jobApplications",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "statuses": [
          "job_application_draft"
        ]
      }
    }
  ],
  "concreteType": "JobApplicationConnection",
  "kind": "LinkedField",
  "name": "freelancerJobApplications",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": "freelancerJobApplications(filters:{\"statuses\":[\"job_application_draft\"]})"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VanityUrlMessage_Query",
    "selections": [
      {
        "alias": "user",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Profile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VanityUrlMessage_Query",
    "selections": [
      {
        "alias": "user",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Profile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "type": "User",
            "abstractKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "903dbece549757883402255529732972",
    "id": null,
    "metadata": {},
    "name": "VanityUrlMessage_Query",
    "operationKind": "query",
    "text": "query VanityUrlMessage_Query(\n  $userId: ID!\n) {\n  user: node(id: $userId) {\n    __typename\n    ... on User {\n      self\n      status\n      profile {\n        openToOpportunities\n        slug\n        id\n      }\n      jobApplications: freelancerJobApplications(filters: {statuses: [job_application_draft]}) {\n        totalCount\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d8f6a15261665fe385e96f05bd29171";

export default node;
